// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1236":"88446a80","1633":"bc26a60b","1978":"59925ef2","5885":"bbd9fb3e","9785":"1adee6b4"}[chunkId] + ".chunk.css";
};